import { render, staticRenderFns } from "./SectionSocial.vue?vue&type=template&id=7f44f018&scoped=true"
import script from "./SectionSocial.vue?vue&type=script&lang=js"
export * from "./SectionSocial.vue?vue&type=script&lang=js"
import style0 from "./SectionSocial.vue?vue&type=style&index=0&id=7f44f018&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f44f018",
  null
  
)

export default component.exports